import Vue from 'vue';
import i18next from 'i18next';
import VueI18Next from '@panter/vue-i18next';
import _ from 'lodash';

export const languages = ['en', 'it', 'sl', 'de', 'fr'];

Vue.use(VueI18Next);

i18next.init({
  languages,
  lng: languages[0],
  fallbackLng: languages[0],
  defaultNS: 'general',
  resources: {},
  interpolation: {
    prefix: ":",
    suffix: " ",
  },
});
var original_add = i18next.addResourceBundle;
i18next.addResourceBundle = function (lang, section, bundle) {
  var replaces = a => a.replace(/\:\:/g, '&#58;');
  var walkclone = obj => {
    if (typeof obj === 'object' && !Array.isArray(obj)) {
      let cloned = {};
      for (let key in obj) {
        cloned[key] = walkclone(obj[key]);
      }
      return cloned;
    } else if (typeof obj === 'string' || typeof obj === 'number') {
      return replaces(obj);
    }
    return obj;
  };
  return original_add(lang, section, walkclone(bundle));
};

Vue.component('languages', {
  name: 'languages',
  data () {
    return {
      lang: this.$i18n.i18next.language,
      languages,
    };
  },
  template:
    '<select v-model="lang">\
      <option v-for="lng in languages" :value="lng">\
        {{ \'locales.\' + lng | trans }}\
      </option>\n\
    </select>',
  watch: {
    lang () {
      if (this.lang != this.$i18n.i18next.language) {
        i18next.changeLanguage(this.lang);
        if (this.$route && this.$route.name) {
          var params = this.$route.params || {};
          params.lang = this.lang;
          //this works, I don't know why exactly
          this.$router.push({
            name: this.$route.name,
            params,
          });
          this.$router.go(this.$router.currentRoute);
        }
      }
    },
  },
});

Vue.component('router-link-i18n', {
  name: 'router-link-i18n',
  props: {
    to: {
      type: Object,
      required: true
    },
    tag: {
      type: String,
      default: 'a'
    },
    exact: Boolean,
    append: Boolean,
    replace: Boolean,
    activeClass: String,
    exactActiveClass: String,
    event: {
      type: [String, Array],
      default: 'click'
    },
  },
  computed: {
    toi18n () {
      var to = Object.assign({}, this.to);
      if (_.has(this.$route, 'params.lang')) {
        if (!to.params) {
          to.params = {};
        }
        to.params.lang = this.$route.params.lang;
      }
      return to;
    },
  },
  render (el) {
    return el(
      'router-link', {
        props: {
          to: this.toi18n,
          tag: this.tag,
          exact: this.exact,
          append: this.append,
          replace: this.replace,
          activeClass: this.activeClass,
          exactActiveClass: this.exactActiveClass,
          event: this.event,
        },
      }, this.$slots.default
    );
  },
});

var i18n = new VueI18Next(i18next);
export default i18n;


// WEBPACK FOOTER //
// ./src/providers/i18n.js